// 文章等级
const sGradeMap = ['A','S-','S','S+']
const sGrade = window.cfgs && window.cfgs.Sgrade
const articleGrade = sGradeMap[Number(sGrade)]
const whiteList = ['A']
const isShowAd = whiteList.includes(articleGrade)

export default {
    isShowAd,
}